import React from "react";
import { Link } from "react-router-dom";
import { Check, Zap } from "lucide-react";
import { TextQuoteButton } from "../home/TextQuoteButton";
import { useContent, fill } from "../../lib/content";
import { company } from "../../data/mock";
import { QUICK_JOBS, SUPPLY_LINE } from "../../data/audioQuote";

export const AudioQuickJobs = () => {
  const c = useContent();
  return (
    <div data-testid="audio-quick-jobs" className="mb-8 rounded-2xl bg-[#f5f8ff] border border-slate-200 p-5">
      <p className="font-bold text-[#0a1f44]">Quick audio jobs</p>
      <ul className="mt-3 space-y-2">
        {QUICK_JOBS.map((j, i) => (
          <li key={j} data-testid={`audio-quick-job-${i}`} className="flex items-start gap-2 text-sm text-slate-700">
            <Check className="w-4 h-4 mt-0.5 text-[#3b9dff] shrink-0" /> {j}
          </li>
        ))}
      </ul>
      <div className="mt-5 flex flex-wrap items-center gap-3">
        <TextQuoteButton href={company.audioPhotoSms} testId="audio-text-quote-btn" label={fill(c.hero.ctaLabel, c)} className="!text-sm !px-5 !py-3" />
        <Link to="/tv-mounting-quote" data-testid="audio-instant-quote-btn" className="inline-flex items-center gap-2 px-5 py-3 rounded-full border-2 border-[#0a1f44]/20 text-[#0a1f44] font-bold text-sm hover:bg-white transition-colors">
          <Zap className="w-4 h-4 text-[#3b9dff]" /> Instant Quote
        </Link>
      </div>
      <p data-testid="audio-supply-line" className="mt-4 text-sm text-slate-600">{SUPPLY_LINE}</p>
    </div>
  );
};
